import { BaseReducerState, Response } from '../../../services'
import { ActionTypes } from '../actions'

export interface BillPDFAPIResponse extends Response {
  data: string
}

export type BillPDFState = BaseReducerState & {
  data: string
}

const todayBillInitialState: BillPDFState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const billPDF = (
  state: BillPDFState = todayBillInitialState,
  action: { type: string; res: any }
): BillPDFState => {
  switch (action.type) {
    case `${ActionTypes.GET_TODAY_BILL_PDF}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.GET_TODAY_BILL_PDF}_SUCCESS`: {
      const { success, data, message } = <BillPDFAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.GET_TODAY_BILL_PDF}_FAILURE`:
      const res = <BillPDFAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.GET_TODAY_BILL_PDF}_RESET`:
      return {
        ...state,
        loading: false,
        success: false,
        message: null,
        data: null,
        error: null,
      }
  }
  return state
}
